module.exports = __webpack_public_path__ + "static/media/Nunito-SemiBold.713ac08d.ttf";